import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/${number | ':id'}${`?date=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:id`;

export const URL = (id: number, /** YYYY-MM-DD */date: string): RouteDefinition => `${baseRoute}/${id}?date=${date}`;
